import {
	Component,
	Input,
	Output,
	EventEmitter,
	forwardRef,
	ViewEncapsulation,
	ElementRef,
	ViewChild,
	OnDestroy,
	SimpleChanges,
	OnChanges
} from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { IdService } from "../shared/services/id.service";
import { FormControlBase } from "../shared/classes/form-control-base";
import { Observable, fromEvent } from "rxjs";
import { take } from "rxjs/operators";

@Component({
	selector: "rbc-tag",
	template: `
		<div
			*ngIf="checkable; else alternative"
			class="rbc-tag"
			(blur)="touch()"
			#tagWrapper
		>
			<input
				#control
				[id]="id"
				[checked]="innerValue"
				[ngModel]="innerValue"
				[disabled]="disabled"
				[name]="name"
				class="rbc-tag-control"
				type="checkbox"
				(change)="emitTagUpdate()"
			/>
			<label
				[id]="id+'Label'"
				[ngClass]="{
					disabled: disabled,
					'rbc-tag-small': size == 'small',
					'rbc-tag-medium': size == 'medium',
					'rbc-tag-large': size == 'large'
				}"
				[ngStyle]="{
					height: height && size === 'large' ? height : null
				}"
				[for]="id"
				class="rbc-tag-label"
			>
				<ng-container *ngTemplateOutlet="defaultContent"></ng-container>
				<rbc-icon
					aria-hidden="true"
					class="rbc-tag-icon"
					icon="times"
					role="none"
				></rbc-icon>
			</label>
		</div>

		<ng-template #alternative>
			<span
				[id]="id"
				[ngClass]="{
					'rbc-tag-small': size == 'small',
					'rbc-tag-medium': size == 'medium',
					'rbc-tag-large': size == 'large'
				}"
				class="rbc-tag-label"
			>
				<ng-container *ngTemplateOutlet="defaultContent"></ng-container>
			</span>
		</ng-template>

		<ng-template #defaultContent> <ng-content></ng-content> </ng-template>
	`,
	styles: [],
	encapsulation: ViewEncapsulation.None,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			useExisting: forwardRef(() => TagComponent)
		}
	]
})
export class TagComponent extends FormControlBase<boolean>
	implements OnChanges, OnDestroy {
	@Input() checkable = false;
	@Input() checked = false;
	@Input() disabled: boolean | string;
	@Input() height: string;
	@Input() id;
	@Input() name = "info";
	@Input() size: "small" | "medium" | "large" = "medium";

	@Output() tagUpdate = new EventEmitter();

	@ViewChild("control", { static: false }) $control: ElementRef;
	@ViewChild("tagWrapper", { static: false }) tagWrapper: ElementRef;

	mouseoutObservable: Observable<any>;

	constructor(private idService: IdService) {
		super();
		this.id = idService.generate();
	}

	ngOnChanges(changes: SimpleChanges) {
		super.ngOnChanges(changes);

		if (changes && changes.checked) {
			this.writeValue(changes.checked.currentValue);
		}
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
		super.ngOnDestroy();
	}

	removeFocus() {
		this.$control.nativeElement.blur();
		this.mouseoutObservable = null;
	}

	emitTagUpdate() {
		this.setModel(!this.innerValue);
		this.tagUpdate.emit({ name: this.name, checked: this.innerValue });

		if (!this.mouseoutObservable) {
			this.mouseoutObservable = fromEvent(
				this.tagWrapper.nativeElement,
				"mouseout"
			);

			this.mouseoutObservable
				.pipe(take(1))
				.subscribe(this.removeFocus.bind(this));
		}
	}
}
